import React, { useCallback, useMemo, useState, useEffect } from 'react';
import { MaterialReactTable } from 'material-react-table';
import {
    Box,
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    IconButton,
    MenuItem,
    Autocomplete,
    Stack,
    TextField,
    Tooltip,
} from '@mui/material';
import { Delete, Edit, Download } from '@mui/icons-material';
import { MRT_Localization_PT_BR } from 'material-react-table/locales/pt-BR';
import api from '../api/axios';
import { htmlFollow } from "../constants/htmlCreationCompany";

const lib = ['sim', 'não']

const Empresa = () => {
    const [createModalOpen, setCreateModalOpen] = useState(false);
    const [tableData, setTableData] = useState({});
    const [cityData, setCityData] = useState([])
    const [company, setCompany] = useState([])
    const [param, setParam] = useState([])
    const [users, setUsers] = useState([])
    const [validationErrors, setValidationErrors] = useState({});

    const getCityList = async () => {
        await api.get('/city/list')
            .then(res => {
                res.data.map((item) => item.label = item.name)
                setCityData(res.data)
            })
            .catch(err => console.log(err))
    }

    const getCompany = async (row) => {
        var ret
        console.log(row.getValue('_id'))
        await api.get('/company/find/' + row.getValue('_id'))
            .then(res => {
                setCompany(res.data)
                console.log(res.data)
                ret = res.data
            })
            .catch(err => console.log(err))
        return ret
    }

    const getCertificate = async (id) => {
        var ret
        await api.get('/certificate/finduser/' + id)
            .then(res => {
                //setCompany(res.data)
                console.log(res.data)
                ret = res.data
            })
            .catch(err => console.log(err))
        return ret
    }

    const getUsers = async (id) => {
        var ret
        //console.log(row.getValue('_id'))
        await api.get('/link/findusers/' + id)
            .then(res => {
                setUsers(res.data)
                console.log(res.data)
                ret = res.data
            })
            .catch(err => console.log(err))
        return ret
    }

    const getParam = async () => {
        var p
        await api.get('/param/list')
            .then(res => {
                setParam(res.data[0])
                p = res.data[0]
            })
            .catch(err => console.log(err))
        return p
    }

    useEffect(() => {
        (async () => {
            //await getCityList()
            await api.get('/company/list')
                .then(res => {
                    setTableData(res.data);
                    //console.log(res.data)
                })
                .catch(err => console.log(err))
        })();
    }, []);

    const handleCertificatePDF = async (row) => {
        var c = await getCompany(row)
        var p = await getParam()
        var u = await getUsers(row.getValue('_id'))
        var uv = []
        //setTimeout('', 15000)
        if (u.length == 0) {
            alert('Nenhum despachante válido nesta empresa!!!')
            return;
        }
        for (var cont = 0; cont < u.length; cont++){
            //console.log(u[cont].user._id)
            //var i = await getCertificate(u[cont].user._id)
            //console.log(i)
            //if (i.length > 0){
                //console.log(i)
                uv.push(u[cont].user)
            //}
        }
        //console.log(uv)
        if (uv.length == 0) {
            alert('Nenhum despachante válido nesta empresa!!!')
            return;
        }
        const html = await htmlFollow(row, c, p, uv)
        console.log('foi 0')
        var newwindows = window.open()
        console.log('foi 2')
        newwindows.document.write(html)

        setTimeout(function () {
            newwindows.print()
            newwindows.close()
        }, 1000)
    }

    const handleCreateNewRow = async (values) => {
        if (!values.name) {
            alert('Nome é obrigatório!!!')
            return;
        }
        delete values._id
        await api.post('/company/insert/', values)
            .then(res => {
                tableData.push(res.data);
                setTableData([...tableData]);
            })
            .catch(err => console.log(err))

    };

    const handleSaveRowEdits = async ({ exitEditingMode, row, values }) => {
        if (!Object.keys(validationErrors).length) {
            //values.relacionamento = values.relacionamento == 'sim' ? 'true' : 'false'
            tableData[row.index] = values;
            await api.put('/company/update/' + values._id, values)
                .then(res => {
                    setTableData([...tableData]);
                })
                .catch(err => console.log(err))
            exitEditingMode(); //required to exit editing mode and close modal
        }
    };

    const handleCancelRowEdits = () => {
        setValidationErrors({});
    };

    const handleDeleteRow = useCallback(
        async (row) => {
            if (
                !window.confirm(`Confirma exclusão de ${row.getValue('name')}`)
            ) {
                return;
            }
            //send api delete request here, then refetch or update local table data for re-render

            try {
                const response = await api.delete('/company/delete/' + row.getValue('_id'));
                tableData.splice(row.index, 1);
                setTableData([...tableData]);
            } catch (error) {
                if (error.response) {
                    console.log(error.response.status);
                } else if (error.request) {
                    console.log(error.request);
                } else {
                    console.log('Error', error.message);
                }
            }
        },
        [tableData],
    );

    const getCommonEditTextFieldProps = useCallback(
        (cell) => {
            return {
                error: !!validationErrors[cell.id],
                helperText: validationErrors[cell.id],
                onBlur: (event) => {
                    const isValid =
                        cell.column.id === 'email'
                            ? validateEmail(event.target.value)
                            : cell.column.id === 'age'
                                ? validateAge(+event.target.value)
                                : validateRequired(event.target.value);
                    if (!isValid) {
                        //set validation error for cell if invalid
                        setValidationErrors({
                            ...validationErrors,
                            [cell.id]: `${cell.column.columnDef.header} is required`,
                        });
                    } else {
                        //remove validation error for cell if valid
                        delete validationErrors[cell.id];
                        setValidationErrors({
                            ...validationErrors,
                        });
                    }
                },
            };
        },
        [validationErrors],
    );

    const columns = useMemo(
        () => [
            {
                accessorKey: '_id',
                header: 'ID',
                enableColumnOrdering: false,
                enableEditing: false, //disable editing on this column
                enableSorting: false,
                size: 80,
            },
            {
                accessorKey: 'document',
                header: 'Documento',
                size: 140,
                muiTableBodyCellEditTextFieldProps: ({ cell }) => ({
                    ...getCommonEditTextFieldProps(cell),
                }),
            },
            {
                accessorKey: 'name',
                header: 'Nome',
                size: 140,
                muiTableBodyCellEditTextFieldProps: ({ cell }) => ({
                    ...getCommonEditTextFieldProps(cell),
                }),
            },
            {
                accessorKey: 'nameaux',
                header: 'Nome Fantasia',
                size: 140,
                muiTableBodyCellEditTextFieldProps: ({ cell }) => ({
                    ...getCommonEditTextFieldProps(cell),
                }),
            },
            {
                accessorKey: 'cep',
                header: 'CEP',
                size: 80,
                muiTableBodyCellEditTextFieldProps: ({ cell }) => ({
                    ...getCommonEditTextFieldProps(cell),
                }),
            },
            {
                accessorKey: 'address',
                header: 'Endereço',
                size: 140,
                muiTableBodyCellEditTextFieldProps: ({ cell }) => ({
                    ...getCommonEditTextFieldProps(cell),
                }),
            },
            {
                accessorKey: 'number',
                header: 'Número',
                size: 80,
                muiTableBodyCellEditTextFieldProps: ({ cell }) => ({
                    ...getCommonEditTextFieldProps(cell),
                }),
            },
            {
                accessorKey: 'complement',
                header: 'Complemento',
                size: 100,
                muiTableBodyCellEditTextFieldProps: ({ cell }) => ({
                    ...getCommonEditTextFieldProps(cell),
                }),
            },
            {
                accessorKey: 'district',
                header: 'Bairro',
                size: 100,
                muiTableBodyCellEditTextFieldProps: ({ cell }) => ({
                    ...getCommonEditTextFieldProps(cell),
                }),
            },
            {
                accessorKey: 'city',
                header: 'Cidade',
                size: 100,
                muiTableBodyCellEditTextFieldProps: ({ cell }) => ({
                    ...getCommonEditTextFieldProps(cell),
                }),
            },
            {
                accessorKey: 'state',
                header: 'Estado',
                size: 80,
                muiTableBodyCellEditTextFieldProps: ({ cell }) => ({
                    ...getCommonEditTextFieldProps(cell),
                }),
            },
            /*{
              accessorFn: (row) => new Date(row.data_nasc), //convert to Date for sorting and filtering
              accessorKey: 'data_nasc',
              header: 'Data Nascimento',
              enableColumnOrdering: false,
              enableEditing: false, //disable editing on this column
              size: 80,
              Cell: ({ cell }) => cell.getValue()?.toLocaleDateString(), 
              muiTableBodyCellEditTextFieldProps: ({ cell }) => ({
                  ...getCommonEditTextFieldProps(cell),
                  value: cell.getValue()?.toLocaleDateString()
                }),
            },*/
            /*{
                //accessorFn: (row) => 'Curitiba',//cityData.filter(city => (city._id == row.city)).name,
                accessorKey: 'city',
                header: 'Município',
                Cell: ({ cell }) => {
                    var x = cityData.filter(city => (city._id === cell.getValue()))
                    return x[0].name
                },
                muiTableBodyCellEditTextFieldProps: ({ cell }) => ({
                    children: cityData.map((city) => (
                        <MenuItem key={city._id} value={city._id}>
                            {city.name}
                        </MenuItem>
                    )),
                    select: true,
                }),
            },
            /*{
              //accessorFn: (row) => row.liberado ? 'sim' : 'não',
              accessorKey: 'modality',
              header: 'Modalidade',
              muiTableBodyCellEditTextFieldProps: ({ cell }) => ({
                  children: modality_list.map((modality) => (
                      <MenuItem key={modality} value={modality}>
                        {modality}
                      </MenuItem>
                  )),
                  select: true,
              }),
            },
            {
              //accessorFn: (row) => row.liberado ? 'sim' : 'não',
              accessorKey: 'status',
              header: 'Status',
              muiTableBodyCellEditTextFieldProps: ({ cell }) => ({
                  children: situation_list.map((status) => (
                      <MenuItem key={status} value={status}>
                        {status}
                      </MenuItem>
                  )),
                  select: true,
              }),
            },
            /*{
              accessorFn: (row) => row.liberado ? 'sim' : 'não',
              accessorKey: 'relacionamento',
              header: 'Relacionamento',
              muiTableBodyCellEditTextFieldProps: ({ cell }) => ({
                  children: lib.map((lib) => (
                      <MenuItem key={lib} value={lib}>
                        {lib}
                      </MenuItem>
                  )),
                  select: true,
              }),
            },
            {
              accessorKey: 'instagram',
              header: 'Instagram',
              muiTableBodyCellEditTextFieldProps: ({ cell }) => ({
                  ...getCommonEditTextFieldProps(cell),
              }),
            },
            {
              accessorKey: 'bio',
              header: 'Bio',
              muiTableBodyCellEditTextFieldProps: ({ cell }) => ({
                  ...getCommonEditTextFieldProps(cell),
              }),
            },
            {
              accessorKey: 'faculdade',
              header: 'Faculdade',
              muiTableBodyCellEditTextFieldProps: ({ cell }) => ({
                  ...getCommonEditTextFieldProps(cell),
              }),
            },
            {
              accessorKey: 'profissao',
              header: 'Profissao',
              muiTableBodyCellEditTextFieldProps: ({ cell }) => ({
                  ...getCommonEditTextFieldProps(cell),
              }),
            },*/
        ],
        [getCommonEditTextFieldProps, cityData],
    );

    return (
        tableData.length > 0 ? (
            <>
                <MaterialReactTable
                    displayColumnDefOptions={{
                        'mrt-row-actions': {
                            muiTableHeadCellProps: {
                                align: 'center',
                            },
                            size: 120,
                        },
                    }}
                    columns={columns}
                    data={tableData}
                    editingMode="modal" //default
                    initialState={{ columnVisibility: { _id: false } }}
                    enableColumnOrdering
                    enableEditing
                    localization={MRT_Localization_PT_BR}
                    onEditingRowSave={handleSaveRowEdits}
                    onEditingRowCancel={handleCancelRowEdits}
                    renderRowActions={({ row, table }) => (
                        <Box sx={{ display: 'flex', gap: '1rem' }}>
                            <Tooltip arrow placement="left" title="Edit">
                                <IconButton onClick={() => table.setEditingRow(row)}>
                                    <Edit />
                                </IconButton>
                            </Tooltip>
                            <Tooltip arrow placement="right" title="Delete">
                                <IconButton color="error" onClick={() => handleDeleteRow(row)}>
                                    <Delete />
                                </IconButton>
                            </Tooltip>
                            <Tooltip arrow placement="right" title="Download">
                                <IconButton onClick={() => handleCertificatePDF(row)}>
                                    <Download />
                                </IconButton>
                            </Tooltip>
                        </Box>
                    )}
                    renderTopToolbarCustomActions={() => (
                        <Button
                            color='warning'
                            onClick={() => setCreateModalOpen(true)}
                            variant="contained"
                        >
                            Criar Nova Empresa
                        </Button>
                    )}
                />
                <CreateNewAccountModal
                    columns={columns}
                    open={createModalOpen}
                    onClose={() => setCreateModalOpen(false)}
                    onSubmit={handleCreateNewRow}
                    cities={cityData}
                />
            </>) : <></>
    );
};

//example of creating a mui dialog modal for creating new rows
export const CreateNewAccountModal = ({ open, columns, onClose, onSubmit, cities }) => {
    const [values, setValues] = useState(() =>
        columns.reduce((acc, column) => {
            acc[column.accessorKey ?? ''] = '';
            return acc;
        }, {}),
    );

    const handleSubmit = () => {
        //put your validation logic here
        onSubmit(values);
        onClose();
    };

    return (
        <Dialog open={open}>
            <DialogTitle textAlign="center">Criar Nova Empresa</DialogTitle>
            <DialogContent>
                <form onSubmit={(e) => e.preventDefault()}>
                    <Stack
                        sx={{
                            width: '100%',
                            minWidth: { xs: '300px', sm: '360px', md: '400px' },
                            gap: '1.5rem',
                        }}
                    >
                        {columns.map((column) => (
                            column.header !== 'ID' ?
                                column.header === 'Município' ?
                                    <Autocomplete
                                        disablePortal
                                        id="combo-box-demo"
                                        onChange={(e, value) => setValues({ ...values, [column.accessorKey]: value._id })}
                                        options={cities}
                                        renderInput={(params) => <TextField {...params} label="Município" />}
                                    /> :
                                    <TextField
                                        key={column.accessorKey}
                                        label={column.header}
                                        name={column.accessorKey}
                                        onChange={(e) =>
                                            setValues({ ...values, [e.target.name]: e.target.value })
                                        }
                                    /> : <></>
                        ))}
                    </Stack>
                </form>
            </DialogContent>
            <DialogActions sx={{ p: '1.25rem' }}>
                <Button onClick={onClose}>Cancelar</Button>
                <Button color="warning" onClick={handleSubmit} variant="contained">
                    Salvar
                </Button>
            </DialogActions>
        </Dialog>
    );
};

const validateRequired = (value) => !!value.length;
const validateEmail = (email) =>
    !!email.length &&
    email
        .toLowerCase()
        .match(
            /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
        );
const validateAge = (age) => age >= 18 && age <= 50;

export default Empresa;

